import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';
import { selectWorks } from '../../../Api/selectors';
import { fetchVehicle, initiateVehicleEdit, setVehicleProperties } from '../../actions';
import { REQUEST_VEHICLE, VEHICLE_FIRST_STEP_FIELD_TYPES, VEHICLE_SECOND_STEP_FIELD_TYPES } from '../../constants';
import { selectNewVehicle, selectVehicle } from '../../selectors';
import { setNewVehicleValue } from '../../actions';
import { StepperCreateHeader } from './Header';
import { VehicleCreateStep1 } from './Step1Base';
import { VehicleCreateStep2 } from './SecondStep/SecondStep';
import { VehicleCreateStep3 } from './ThirdStep/ThirdStep';
import { VehicleCreateStep4 } from './FourthStep/FourthStep';
import { VehicleCreateStep5 } from './FifthStep/FifthStep';

import { OptionsPage } from './OptionsStep/OptionsStep';
import { VehicleCreateInfo } from './VehicleCreateInfoCard';
import { isWithInstallation } from '../../helpers';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import cn from 'classnames';
import styles from './editInner.module.css';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { VehicleCreateStep6 } from './SixtStep/SixtStep';

const Container = styled.div`
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
  }
  .form-block {
    display: flex;
    align-items: baseline;
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
    }
  }
`;

const STATE = {
  stepperClickStep: null,
  stepperClick: false,
  values: null,
  showVehicleInfo: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleEditInnerComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
    this.setState({ values: this.props.values });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get stepsData() {
    let stepsData;
  
    if (env.clientId == AppClientId.INDEWAL) {
      stepsData = {
        steps: 6,
        labels: ['Basic data', 'Financial data', 'Options', 'Documents', 'Vehicle data', 'Advertising data'],
      };
    } else {
      stepsData = {
        steps: 5,
        labels: ['Basic data', 'Financial data', 'Options', 'Documents', 'Vehicle data'],
      };
    }
  
    return stepsData;
  }

  get pageStep() {
    let stepObj = {
      optionPage: 3,
      documentsPage: 4,
      vehicleData: 5,
      advertisingData: 6,
    };

    return stepObj;
  }

  creditorInfo() {
    return {
      creditorCompanyId: this.vehicle['creditorCompany']?.id,
      creditorId: this.vehicle['creditor']?.id,
    };
  }

  save(callback) {
    let properties = [];

    for (let i in this.props.values) {
      if (i === 'wegenbelasting' && this.props.values?.[i]?.toLowerCase() == 'onbekend') {
        continue;
      }

      if (this.props.values[i] !== '') {
        properties.push({
          propertyName: i,
          propertyValue: this.props.values[i],
        });
      }
    }

    let notEqual = Object.entries(this.props.values).filter(([key, val]) => {
      if (val !== '' && !key.split('_').includes('manual')) {
        return this.state.values[key] != val;
      }
      return null;
    });

    if (notEqual.length) {
      return this.props.patch(properties, result => {
        if (result) {
          this.state.stepperClick
            ? this.to(`/vehicles/${this.props.vehicle_id}/edit/${this.state.stepperClickStep}`)
            : this.to(`/vehicles/${this.props.vehicle_id}/edit/${+this.props.step + 1}`);
        }
      });
    } else {
      return this.props.fetch(fetchResult => {
        this.state.stepperClick
          ? this.to(`/vehicles/${this.props.vehicle_id}/edit/${this.state.stepperClickStep}`)
          : this.to(`/vehicles/${this.props.vehicle_id}/edit/${+this.props.step + 1}`);
      });
    }
  }

  getStep(n) {
    n && this.setState({ stepperClickStep: n, stepperClick: true });
  }

  prevStep() {
    this.props.prevStep();
  }

  nextStep() {
    this.props.nextStep();
  }

  updateFromAutotelex() {
    this.props.fetchFromAutotelex();
  }
  toggleVehicleInfo = () => {
    this.setState(prevState => ({ showVehicleInfo: !prevState.showVehicleInfo }));
  };

  render() {
    if (this.props.work) return <Loader small />;

    if (this.props.values.id != this.props.vehicle_id) {
      return <Loader small />;
    }
    if (!this.state.values) {
      return <Loader small />;
    }

    return (
      <Container>
        <PageHeader
          title={
            <div className="pointer" onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>
              <Left />
              {this.lbl('vehicles')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('vehicles')}
              <ChevronRight />

              {this.lbl('add')}
            </>
          }
        />

        <StepperCreateHeader
          edit
          steps_quantity={this.stepsData?.steps}
          model={'vehicle'}
          model_id={this.props.vehicle_id}
          labelArr={this.stepsData?.labels}
          step={this.props.step}
          onSave={this.save.bind(this)}
          getStep={this.getStep.bind(this)}
          onIncrement={this.prevStep.bind(this)}
          onDecrement={this.nextStep.bind(this)}
        />

        <div className={cn('form-block', styles.flexBox)}>
          {window.innerWidth <= 768 && this.props.step > 1 && (
            <div className={styles.buttonVehicleInfo}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.toggleVehicleInfo}>
                {this.lbl(`vehicle.info.data.vehicle_info`)}
              </ButtonComponent>
            </div>
          )}

          {this.state.showVehicleInfo && (
            <VehicleCreateInfo
              vehicle_id={this.props.vehicle_id}
              data={['regplate', 'brand_name', 'model_name', 'date_first_allowance', 'mileage', 'base_color', 'fuel_type']}
            />
          )}

          {this.props.step === 1 && (
            <VehicleCreateStep1
              edit
              vehicle_id={this.props.vehicle_id}
              fetchFromAutotelex={this.updateFromAutotelex.bind(this)}
              onSave={this.save.bind(this)}
            />
          )}
          {this.props.step === 2 && (
            <VehicleCreateStep2
              vehicle_id={this.props.vehicle_id}
              creditorInfo={this.creditorInfo()}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}

          {this.props.step === this.pageStep?.optionPage && (
            <OptionsPage
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
              vehicle_id={this.props.vehicle_id}
            />
          )}
          {this.props.step === this.pageStep?.documentsPage && (
            <VehicleCreateStep4
              vehicle_id={this.props.vehicle_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === this.pageStep?.vehicleData && (
            <VehicleCreateStep5
              vehicle_id={this.props.vehicle_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === this.pageStep?.advertisingData && (
            <VehicleCreateStep6
              vehicle_id={this.props.vehicle_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step > 1 && window.innerWidth > 769 && (
            <VehicleCreateInfo
              vehicle_id={this.props.vehicle_id}
              data={['regplate', 'brand_name', 'model_name', 'date_first_allowance', 'mileage', 'base_color', 'fuel_type']}
            />
          )}
        </div>
      </Container>
    );
  }
}

VehicleEditInnerComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateVehicleEdit(ownProps.vehicle_id));
    },
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle_id, props, callback));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
    fetch(callback) {
      dispatch(fetchVehicle(ownProps.vehicle_id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleEditInner = compose(withConnect, withRouter)(VehicleEditInnerComp);
